module.exports = new __parcel__URL__("airplane.4c9ccc43.jpg").toString();